module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":{"feed_articles":"Industry Research Articles","activity_list":"activity Lists"},"data":{"entering_year":"Joined in %{year}","school_name":"From %{school}"}}}')
  delete Component.options._Ctor
}
